import React from 'react'
import { Link } from 'react-router-dom'
import { routes } from '../../routes'
import classes from './Footer.module.sass'
import afterpayLogoWhite from '../../assets/Afterpay_Logo_White.png'

const baseUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://shoobphoto.com'

const Footer = () => {
  const href = (link) => `${baseUrl}${link}`

  return (
    <div className={classes.footer}>
      <a href={href('/contacts')}>Privacy &amp; Data Policy</a>
      <a href={href('/contacts/new')}>Contact Us</a>
      <div className={classes.shoob_job} >
      <a className={classes.shoob_job_text}  href={href('/contacts/shoob_job')}>JOB OPENINGS</a></div>
      <a href="https://www.shoobphoto.com/guarantee">Guarantee</a>
      <Link to={routes.frequentlyAskedQuestions()}>Help</Link>
      <div className={classes.afterpayLogoContainer}>
        <img style={{ width: '150px', height: 'auto' }} src={afterpayLogoWhite} alt="AfterPay Logo" />
        <span className={classes.afterPayText}>now available for orders greater than $35</span>
      </div>
    </div>
  )
}

export default Footer
